// extracted by mini-css-extract-plugin
export var anchor = "_3r-0";
export var discard = "_3r-4";
export var muiTooltipTooltip = "_3r-6";
export var notificationBar = "_3r-3";
export var saveButtonHoverSlotWrapper = "_3r-5";
export var show = "_3r-2";
export var spacer = "_3r-1";